/* ==========================================================================
   Coffee Finder: quiz flow + taste matching
   Data model: every candidate lives in the hidden pool as <article.cf-pool-card>
   with data-* taste scores rendered server-side from real products.
   Matching = weighted nearest-neighbour on corpo × acidità × caffeina.
   All user-facing copy comes from the [data-cf-i18n] JSON blob (bilingual).
   ========================================================================== */
(function () {
  'use strict';

  function initFinder(root) {
    if (!root || root.dataset.cfReady) return;
    root.dataset.cfReady = '1';

    var i18n = {};
    var i18nEl = root.querySelector('[data-cf-i18n]');
    try { i18n = JSON.parse(i18nEl.textContent); } catch (e) { i18n = {}; }

    var steps = Array.prototype.slice.call(root.querySelectorAll('.cf__step'));
    var intro = root.querySelector('.cf__intro');
    var quiz = root.querySelector('[data-cf-quiz]');
    var resultWrap = root.querySelector('[data-cf-result]');
    var resultBody = root.querySelector('[data-cf-result-content]');
    var bar = root.querySelector('[data-cf-bar]');
    var progLabel = root.querySelector('[data-cf-progress-label]');
    var backBtn = root.querySelector('[data-cf-back]');
    var pool = Array.prototype.slice.call(root.querySelectorAll('.cf-pool-card'));

    var answers = {};
    var current = 0;
    var total = steps.length;

    /* ---------------- shareable result (hash URL) ---------------- */
    var AXES = ['format', 'corpo', 'acidita', 'avoid', 'latte', 'momento', 'caffeina', 'explore'];

    function encode64(str) {
      try { return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); } catch (e) { return ''; }
    }

    function decode64(str) {
      try {
        var pad = str.replace(/-/g, '+').replace(/_/g, '/');
        while (pad.length % 4) pad += '=';
        return atob(pad);
      } catch (e) { return null; }
    }

    function answersToHash() {
      var vals = AXES.map(function (a) { return answers[a] || ''; });
      if (vals.indexOf('') !== -1) return '';
      var enc = encode64(vals.join('.'));
      return enc ? '#cf=' + enc : '';
    }

    function answersFromHash() {
      var m = (window.location.hash || '').match(/^#cf=([A-Za-z0-9_.-]+)$/);
      if (!m) return null;
      // base64url; i primi link condivisi usavano il formato in chiaro coi punti
      var raw = m[1].indexOf('.') !== -1 ? m[1] : decode64(m[1]);
      if (!raw) return null;
      var vals = raw.split('.');
      if (vals.length !== AXES.length) return null;
      var out = {};
      for (var i = 0; i < AXES.length; i++) {
        if (!/^[a-z0-9]+$/.test(vals[i])) return null;
        out[AXES[i]] = vals[i];
      }
      return out;
    }

    // Reflect restored answers on the quiz buttons, so going back from the
    // result shows the quiz in the state that produced it.
    function paintSelections() {
      steps.forEach(function (step) {
        var v = answers[step.dataset.axis];
        if (!v) return;
        step.querySelectorAll('.cf__opt').forEach(function (o) {
          var on = o.dataset.value === v;
          o.classList.toggle('is-selected', on);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        step.querySelectorAll('.cf__bean').forEach(function (b, i) {
          b.classList.toggle('is-on', i < parseFloat(v));
          b.setAttribute('aria-pressed', b.dataset.value === v ? 'true' : 'false');
        });
      });
    }

    function t(key, fallback) { return (key in i18n) ? i18n[key] : (fallback || key); }

    // Scroll all'inizio della sezione compensando lo sticky header
    // (riappare scrollando verso l'alto e coprirebbe il titolo).
    function scrollToQuizTop(el) {
      var target = el || intro || root;
      var header = document.querySelector('sticky-header');
      var offset = header ? header.getBoundingClientRect().height + 8 : 8;
      var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    function track(name, params) {
      try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* analytics must never break the quiz */ }
    }

    // Counterpart of the USER-scoped GA4 custom dimension "quiz_user": flags the
    // user so later events (purchases included) can be tied back to the quiz.
    // Must run BEFORE the quiz_complete event so that event already carries it.
    function setQuizUserFlag() {
      try { if (typeof window.gtag === 'function') window.gtag('set', 'user_properties', { quiz_user: 'yes' }); } catch (e) { /* analytics must never break the quiz */ }
    }

    function showStep(n, moveFocus) {
      current = Math.max(0, Math.min(n, total - 1));
      steps.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      var pct = ((current + 1) / total) * 100;
      if (bar) bar.style.width = pct + '%';
      if (progLabel) {
        progLabel.textContent = (t('progress', 'Domanda {n} di {total}'))
          .replace('{n}', current + 1).replace('{total}', total);
      }
      if (backBtn) backBtn.hidden = current === 0;
      if (moveFocus) {
        var leg = steps[current].querySelector('.cf__question');
        if (leg) { leg.setAttribute('tabindex', '-1'); leg.focus({ preventScroll: true }); }
      }
    }

    // Warm the browser cache with the profile images while the user answers,
    // so the result's profile image appears instantly instead of fetching then.
    // Deferred to mid-quiz: no ~0.5MB spent on who bounces after a click.
    var imagesPreloaded = false;
    function preloadFamilyImages() {
      if (imagesPreloaded || !i18n.families) return;
      imagesPreloaded = true;
      Object.keys(i18n.families).forEach(function (k) {
        var src = i18n.families[k] && i18n.families[k].img;
        if (src) { var im = new Image(); im.src = src; }
      });
    }

    var quizStarted = false;

    // One event per answered question (quiz_step_1 … quiz_step_N, N = position
    // of the question) so GA4 shows where people drop off by event name alone.
    // Going back and answering again counts again.
    function stepNumber(axis) {
      for (var i = 0; i < steps.length; i++) {
        if (steps[i].dataset.axis === axis) return i + 1;
      }
      return current + 1;
    }

    function commitAnswer(axis, value) {
      answers[axis] = value;
      if (Object.keys(answers).length >= 4) preloadFamilyImages();
      if (!quizStarted) {
        quizStarted = true;
        track('quiz_start', { quiz_format: answers.format || '' });
      }
      track('quiz_step_' + stepNumber(axis), { quiz_format: answers.format || '' });
      if (current < total - 1) {
        setTimeout(function () { showStep(current + 1, true); }, 320);
      } else {
        setTimeout(computeResult, 260);
      }
    }

    function selectOption(step, opt) {
      step.querySelectorAll('.cf__opt').forEach(function (o) {
        o.classList.remove('is-selected');
        o.setAttribute('aria-pressed', 'false');
      });
      opt.classList.add('is-selected');
      opt.setAttribute('aria-pressed', 'true');
      commitAnswer(step.dataset.axis, opt.dataset.value);
    }

    steps.forEach(function (step) {
      step.querySelectorAll('.cf__opt').forEach(function (opt) {
        opt.setAttribute('aria-pressed', 'false');
        opt.addEventListener('click', function () { selectOption(step, opt); });
      });
    });

    // Rating question (corpo): beans fill up to the chosen one, review-style.
    root.querySelectorAll('[data-cf-rating]').forEach(function (rat) {
      var beans = Array.prototype.slice.call(rat.querySelectorAll('.cf__bean'));
      var ratStep = rat.closest('.cf__step');
      var axis = ratStep ? ratStep.dataset.axis : '';
      function paint(n, cls) { beans.forEach(function (b, i) { b.classList.toggle(cls, i < n); }); }
      beans.forEach(function (b, i) {
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('mouseenter', function () { paint(i + 1, 'is-hover'); });
        b.addEventListener('focus', function () { paint(i + 1, 'is-hover'); });
        b.addEventListener('click', function () {
          paint(i + 1, 'is-on');
          beans.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          commitAnswer(axis, b.dataset.value);
        });
      });
      rat.addEventListener('mouseleave', function () { paint(0, 'is-hover'); });
      rat.addEventListener('focusout', function (e) {
        if (!rat.contains(e.relatedTarget)) paint(0, 'is-hover');
      });
    });

    // Delegated: result interactions (add to cart, club CTA, outbound clicks)
    if (resultBody) {
      resultBody.addEventListener('click', function (e) {
        if (!e.target.closest) return;
        var addBtn = e.target.closest('[data-cf-add]');
        if (addBtn) { addToCart(addBtn); return; }
        var shareBtn = e.target.closest('[data-cf-share]');
        if (shareBtn) { copyShareLink(shareBtn); return; }
        var clubBtn = e.target.closest('[data-cf-club]');
        if (clubBtn) {
          track('quiz_club_click', {});
          document.dispatchEvent(new CustomEvent('vclub:open'));
          return;
        }
        var a = e.target.closest('a[data-cf-track]');
        if (!a) return;
        var role = a.getAttribute('data-cf-track');
        track(role === 'nudge' ? 'quiz_nudge_click' : 'quiz_result_click', {
          quiz_product: a.getAttribute('data-cf-handle') || '',
          quiz_role: role
        });
      });
    }

    if (backBtn) backBtn.addEventListener('click', function () { showStep(current - 1, true); });

    function resetQuiz() {
      answers = {};
      quizStarted = false;
      steps.forEach(function (s) {
        s.querySelectorAll('.cf__opt').forEach(function (o) {
          o.classList.remove('is-selected');
          o.setAttribute('aria-pressed', 'false');
        });
        s.querySelectorAll('.cf__bean').forEach(function (b) {
          b.classList.remove('is-on', 'is-hover');
          b.setAttribute('aria-pressed', 'false');
        });
      });
      resultWrap.hidden = true;
      if (intro) intro.classList.remove('cf__intro--result');
      quiz.hidden = false;
      if (window.location.hash && window.history && history.replaceState) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      showStep(0, true);
      scrollToQuizTop();
    }

    /* ---------------- matching ---------------- */
    var CAFF_TARGET = { decaf: 0, leggera: 1.5, normale: 3, carica: 5 };

    function num(el, attr) { return parseFloat(el.dataset[attr]); }

    function poolByRole(role) {
      return pool.filter(function (c) { return c.dataset.role === role; });
    }

    function eligible() {
      var fmt = answers.format;
      var role = fmt === 'capsule' ? 'capsule' : (fmt === 'cialde' ? 'cialde' : 'match');
      var list = poolByRole(role);
      if (role === 'match') {
        list = list.filter(function (c) {
          return (' ' + c.dataset.formats + ' ').indexOf(' ' + fmt + ' ') !== -1;
        });
      }
      return list;
    }

    // Effective target profile from the answers, with the modifier questions applied:
    // milk raises the ideal body (needs body to cut through), evening lowers caffeine.
    function answerProfile() {
      var corpo = parseFloat(answers.corpo);
      if (answers.latte === 'latte') corpo = Math.min(5, corpo + 1);
      else if (answers.latte === 'dipende') corpo = Math.min(5, corpo + 0.5);
      var caff = CAFF_TARGET[answers.caffeina];
      if (answers.momento === 'sera') caff = Math.max(0, caff - 1);
      return { corpo: corpo, acidita: parseFloat(answers.acidita), caffeina: caff };
    }

    function scoreCard(c) {
      var tp = answerProfile();
      var s = 1.4 * Math.abs(num(c, 'corpo') - tp.corpo) +
              1.2 * Math.abs(num(c, 'acidita') - tp.acidita) +
              1.0 * Math.abs(num(c, 'caffeina') - tp.caffeina);
      var isDecaf = c.dataset.decaf === '1';
      if (answers.caffeina !== 'decaf' && isDecaf) s += 8; // don't surface decaf unless asked
      // "what you can't forgive": soft penalties, won't override a strong explicit match
      if (answers.avoid === 'amaro' && num(c, 'caffeina') >= 4 && num(c, 'acidita') <= 1) {
        s += 2.5;
        if (num(c, 'caffeina') === 5) s += 1.5; // 100% robusta (Tosta, Somala): amaro per definizione
      }
      if (answers.avoid === 'acido' && num(c, 'acidita') >= 4) s += 2.5;
      if (answers.explore === 'monorigine' && c.dataset.origin === '1') s -= 1.4;
      if (answers.explore === 'miscela' && c.dataset.origin !== '1') s -= 1.4;
      // "Sorprendimi": lieve preferenza per le miscele d'autore (firma della casa)
      if (answers.explore === 'indifferente' && c.dataset.origin !== '1') s -= 0.7;
      return s;
    }

    function isDecafCard(c) { return c.dataset.decaf === '1'; }

    function rank(list) {
      var decafOnly = answers.caffeina === 'decaf';
      var pooled = list.slice();
      if (decafOnly) {
        var only = pooled.filter(isDecafCard);
        if (!only.length) {
          // Cross-format fallback. For fresh formats stay on fresh coffees
          // (renderFresh must never surface a capsule box); for capsule/cialde
          // any decaf will do (renderCapsule handles the vendor grouping).
          var isCaps = answers.format === 'capsule' || answers.format === 'cialde';
          only = (isCaps ? pool : poolByRole('match')).filter(isDecafCard);
        }
        if (!only.length) only = pool.filter(isDecafCard);
        if (only.length) pooled = only;
      }
      return pooled
        .map(function (c) { return { c: c, s: scoreCard(c) }; })
        // Stable tie-break by handle: same answers always yield the same result,
        // regardless of the (mutable) collection order the pool was rendered in.
        .sort(function (a, b) { return (a.s - b.s) || a.c.dataset.handle.localeCompare(b.c.dataset.handle); })
        .map(function (x) { return x.c; });
    }

    function findByHandle(handle) {
      for (var i = 0; i < pool.length; i++) if (pool[i].dataset.handle === handle) return pool[i];
      return null;
    }

    // The taste profile is generated from the USER'S ANSWERS (it is their taste);
    // products are then ranked to best fit it. Answers drive both, so the shown
    // profile and the suggestions always stay consistent.
    function familyFromAnswers() {
      if (answers.caffeina === 'decaf') return 'decaf';
      var tp = answerProfile();
      var corpo = tp.corpo, acid = tp.acidita, caff = tp.caffeina;
      if (acid >= 4) return 'vivace';
      if (corpo >= 4 && caff >= 4) return 'intenso';
      if (acid <= 2 && corpo >= 3) return 'morbido';
      return 'equilibrato';
    }

    /* ---------------- result rendering ---------------- */
    function esc(str) { return (str || '').replace(/[&<>"]/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[m]; }); }

    function imgHtml(card) {
      var img = card.querySelector('.cf-src-img');
      return img ? img.outerHTML.replace('cf-src-img', 'cf-out-img') : '';
    }
    function priceOf(card) {
      var p = card.querySelector('.cf-src-price');
      return p ? p.textContent : '';
    }

    // Taste profile as spheres + arabica/robusta split, mirroring the theme's
    // product-card preview (card__profilo pattern).
    function profileMetaHtml(card, small) {
      var cls = 'cf__profilo' + (small ? ' cf__profilo--sm' : '');
      if (card.dataset.decaf === '1') {
        return '<div class="' + cls + '"><span class="cf__chip">' + esc(t('chip_decaf', 'Decaffeinato')) + '</span></div>';
      }
      if (!parseFloat(card.dataset.corpo)) return ''; // equipment: no taste profile
      var perc = '';
      var pa = parseFloat(card.dataset.percArabica);
      var pr = parseFloat(card.dataset.percRobusta);
      if (pa > 0 || pr > 0) {
        var bits = [];
        if (pa > 0) bits.push('<span class="cf__perc" style="color:' + esc(card.dataset.colorArabica || '#d70926') + '">' + pa + '% ' + esc(t('label_arabica', 'Arabica')) + '</span>');
        if (pr > 0) bits.push('<span class="cf__perc" style="color:' + esc(card.dataset.colorRobusta || '#d70926') + '">' + pr + '% ' + esc(t('label_robusta', 'Robusta')) + '</span>');
        perc = '<div class="cf__percs">' + bits.join('<span class="cf__percs-sep">|</span>') + '</div>';
      }
      var rows = [
        ['corpo', t('chip_corpo', 'Corpo')],
        ['acidita', t('chip_acidita', 'Acidità')],
        ['caffeina', t('chip_caffeina', 'Caffeina')]
      ].map(function (r) {
        var v = parseFloat(card.dataset[r[0]]) || 0;
        var dots = '';
        for (var i = 1; i <= 5; i++) dots += '<span class="cf__sphere' + (i <= v ? ' cf__sphere--filled' : '') + '"></span>';
        return '<div class="cf__profilo-row"><span class="cf__profilo-label">' + esc(r[1]) + '</span><span class="cf__spheres">' + dots + '</span></div>';
      }).join('');
      return '<div class="' + cls + '">' + perc + rows + '</div>';
    }

    // The right variant follows the user's brewing method (Q1): moka → moka
    // grind, espresso → espresso grind, filter → whole beans.
    function variantFor(card) {
      var key = answers.format === 'moka' ? 'varMoka' : (answers.format === 'espresso' ? 'varEspresso' : 'varGrani');
      var order = [key, 'varGrani', 'varEspresso', 'varMoka'];
      for (var i = 0; i < order.length; i++) {
        if (card.dataset[order[i]]) {
          return { id: card.dataset[order[i]], title: card.dataset[order[i] + 'Title'] || '' };
        }
      }
      return null;
    }

    function trackAttrs(card, role) {
      return ' data-cf-track="' + esc(role) + '" data-cf-handle="' + esc(card.dataset.handle) + '"';
    }

    function heroHtml(card, opts) {
      opts = opts || {};
      var v = variantFor(card);
      var ctas = '<div class="cf__hero-ctas">';
      if (v) {
        ctas += '<button type="button" class="cf__btn" data-cf-add="' + esc(v.id) + '" data-cf-handle="' + esc(card.dataset.handle) + '">' + esc(t('cta_add', 'Aggiungi al carrello')) + '</button>';
      }
      ctas += '<a class="cf__btn' + (v ? ' cf__btn--ghost' : '') + '" href="' + esc(card.dataset.url) + '"' + trackAttrs(card, 'match') + '>' + esc(t('cta_buy', 'Scopri il caffè')) + '</a>';
      ctas += '</div>';
      if (v && v.title) {
        ctas += '<p class="cf__hero-varnote">' + esc(t('variant_note', 'Formato: {v}').replace('{v}', v.title)) + '</p>';
      }
      return '<div class="cf__hero">' +
        '<a class="cf__hero-media" href="' + esc(card.dataset.url) + '"' + trackAttrs(card, 'match') + '>' + imgHtml(card) + '</a>' +
        '<div class="cf__hero-info">' +
          '<h3 class="cf__hero-name">' + esc(card.dataset.name) + '</h3>' +
          (opts.blurb ? '<p class="cf__hero-blurb">' + esc(opts.blurb) + '</p>' : '') +
          profileMetaHtml(card) +
          '<div class="cf__hero-price">' + priceOf(card) + '</div>' +
          ctas +
        '</div>' +
      '</div>';
    }

    function smallCardHtml(card, role) {
      return '<a class="cf-card--out" href="' + esc(card.dataset.url) + '"' + trackAttrs(card, role || 'alt') + '>' +
        '<div class="cf-card__media">' + imgHtml(card) + '</div>' +
        '<div class="cf-card__body">' +
          '<p class="cf-card__name">' + esc(card.dataset.name) + '</p>' +
          (card.dataset.subtitle ? '<p class="cf-card__sub">' + esc(card.dataset.subtitle) + '</p>' : '') +
          profileMetaHtml(card, true) +
          '<span class="cf-card__price">' + priceOf(card) + '</span>' +
        '</div>' +
      '</a>';
    }

    function cardsGrid(list, role) {
      return '<div class="cf__cards">' + list.map(function (c) { return smallCardHtml(c, role); }).join('') + '</div>';
    }

    // A sentence that echoes the user's own answers back, so the match reads as a
    // real consultation ("Based on your answers, you're after a coffee ...").
    function personalizedSummary() {
      var phr = i18n.phr;
      if (!phr) return '';
      var parts = [];
      if (phr.corpo && phr.corpo[answers.corpo]) parts.push(phr.corpo[answers.corpo]);
      if (phr.aroma && phr.aroma[answers.acidita]) parts.push(phr.aroma[answers.acidita]);
      if (answers.latte && phr.latte && phr.latte[answers.latte]) parts.push(phr.latte[answers.latte]);
      if (answers.momento && phr.momento && phr.momento[answers.momento]) parts.push(phr.momento[answers.momento]);
      if (answers.avoid && phr.avoid && phr.avoid[answers.avoid]) parts.push(phr.avoid[answers.avoid]);
      if (!parts.length) return '';
      return (phr.lead ? phr.lead + ' ' : '') + parts.join(', ') + '.';
    }

    function profileBand() {
      var fam = familyFromAnswers();
      var f = (i18n.families && i18n.families[fam]) || { name: '', desc: '', lookfor: '', img: '' };
      var summary = personalizedSummary();
      var shareSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.6" y1="10.7" x2="15.4" y2="6.3"/><line x1="8.6" y1="13.3" x2="15.4" y2="17.7"/></svg>';
      var restartSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>';
      return '<div class="cf__profile">' +
        '<div class="cf__profile-actions">' +
          '<button type="button" class="cf__pbtn" data-cf-restart aria-label="' + esc(t('restart', 'Ricomincia il test')) + '" title="' + esc(t('restart', 'Ricomincia il test')) + '">' + restartSvg + '</button>' +
          '<button type="button" class="cf__pbtn" data-cf-share aria-label="' + esc(t('share', 'Condividi il risultato')) + '" title="' + esc(t('share', 'Condividi il risultato')) + '">' + shareSvg + '</button>' +
        '</div>' +
        (f.img ? '<div class="cf__profile-media"><img src="' + esc(f.img) + '" alt="' + esc(f.name) + '" loading="lazy"' + (f.pos ? ' style="object-position:' + esc(f.pos) + '"' : '') + '></div>' : '') +
        '<div class="cf__profile-text">' +
          '<span class="cf__profile-badge">' + esc(t('family_kicker', 'Il tuo profilo')) + '</span>' +
          '<h2 class="cf__profile-name">' + esc(f.name) + '</h2>' +
          (summary ? '<p class="cf__profile-summary">' + esc(summary) + '</p>' : '') +
          '<p class="cf__profile-desc">' + esc(f.desc) + '</p>' +
          (f.lookfor ? '<p class="cf__profile-lookfor">' + esc(f.lookfor) + '</p>' : '') +
        '</div>' +
      '</div>';
    }

    function renderFresh(ranked) {
      var winner = ranked[0];
      var alts = ranked.slice(1, 3);

      var html = profileBand();
      html += '<p class="cf__match-label">' + esc(t('match_kicker', 'Il caffè Verri giusto per te')) + '</p>';
      html += heroHtml(winner);

      if (alts.length) {
        html += '<p class="cf__alts-title">' + esc(t('alts_title', 'Potrebbero piacerti anche')) + '</p>';
        html += cardsGrid(alts, 'alt');
      }
      html += clubHtml();
      return html;
    }

    function renderCapsule(ranked) {
      var winner = ranked[0];
      var role = winner.dataset.role; // 'capsule' or 'cialde'
      var miscela = winner.dataset.miscela;

      // Show the matched blend across ALL compatible systems (vendors)
      var vendorOptions = poolByRole(role).filter(function (c) { return c.dataset.miscela === miscela; });
      if (!vendorOptions.length) vendorOptions = [winner];

      // Fresh coffees to "come back to": ranked by the user's answers (same basis
      // as the profile), so they stay consistent with the shown profile.
      var freshTop = rank(poolByRole('match')).slice(0, 3);

      // Entry-level equipment
      var machine = poolByRole('equip').filter(function (c) { return c.dataset.vendor === 'machine'; })[0];
      var grinder = poolByRole('equip').filter(function (c) { return c.dataset.vendor === 'grinder'; })[0];
      var equip = [machine, grinder].filter(Boolean);

      var html = profileBand();
      var kicker = role === 'cialde' ? t('match_kicker_cialde', 'La nostra cialda') : t('match_kicker_caps', 'La tua capsula');
      html += '<p class="cf__match-label">' + esc(kicker) + '</p>';
      html += cardsGrid(vendorOptions, role);

      // The wink: come back to fresh coffee
      var nudgeText = t('nudge_text', 'La capsula è comoda, ma il caffè vero è un’altra cosa. La stessa anima, macinata fresca per la tua moka o macchina espresso, è un’altra tazza.');
      html += '<div class="cf__nudge">' +
        '<h3 class="cf__nudge-title">' + esc(t('nudge_title', 'E se tornassi al caffè fresco?')) + '</h3>' +
        '<p class="cf__nudge-text">' + esc(nudgeText) + '</p>' +
        cardsGrid(freshTop, 'nudge') +
      '</div>';

      if (equip.length) {
        html += '<p class="cf__equip-title">' + esc(t('equip_title', 'L’attrezzatura giusta per iniziare')) + '</p>';
        html += cardsGrid(equip, 'equip');
      }
      html += clubHtml();
      return html;
    }

    function addToCart(btn) {
      if (btn.disabled) return;
      var id = parseInt(btn.getAttribute('data-cf-add'), 10);
      if (!id) return;
      btn.disabled = true;
      var orig = btn.textContent;
      var notif = document.querySelector('cart-notification');
      var body = { items: [{ id: id, quantity: 1 }] };
      if (notif && typeof notif.getSectionsToRender === 'function') {
        body.sections = notif.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (state) {
        if (state.status && state.status !== 200) throw new Error(state.description || 'add failed');
        track('quiz_add_to_cart', { quiz_product: btn.getAttribute('data-cf-handle') || '' });
        btn.textContent = t('added', 'Aggiunto ✓');
        if (notif && typeof notif.renderContents === 'function') notif.renderContents(state);
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2500);
      }).catch(function () {
        btn.textContent = t('add_error', 'Riprova');
        btn.disabled = false;
      });
    }

    // Verri Club band: skipped for already-subscribed customers; the CTA opens
    // the existing #vclub-popup via the vclub:open event.
    function clubHtml() {
      var popup = document.getElementById('vclub-popup');
      if (!popup || popup.dataset.customerConsent === 'true') return '';
      return '<div class="cf__club">' +
        '<span class="cf__club-pill">' + esc(t('club_pill', 'Verri Club')) + '</span>' +
        '<h3 class="cf__club-title">' + esc(t('club_title', 'Iscriviti al Verri Club')) + '</h3>' +
        '<p class="cf__club-text">' + esc(t('club_copy', '')) + '</p>' +
        '<button type="button" class="cf__btn" data-cf-club>' + esc(t('club_cta', 'Iscriviti al club')) + '</button>' +
      '</div>';
    }

    function fallbackCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* niente clipboard: pazienza */ }
      document.body.removeChild(ta);
    }

    function copyShareLink(btn) {
      var url = window.location.href;
      var orig = btn.innerHTML;
      var done = function () {
        btn.innerHTML = '✓';
        btn.setAttribute('title', t('share_copied', 'Link copiato ✓'));
        setTimeout(function () {
          btn.innerHTML = orig;
          btn.setAttribute('title', t('share', 'Condividi il risultato'));
        }, 2000);
      };
      track('quiz_share_click', {});
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { fallbackCopy(url); done(); });
      } else {
        fallbackCopy(url);
        done();
      }
    }

    function computeResult(restored) {
      var ranked = rank(eligible());
      if (!ranked.length) { // safety net: never dead-end
        ranked = rank(poolByRole('match'));
      }
      var isCaps = answers.format === 'capsule' || answers.format === 'cialde';
      if (!restored) {
        // Only genuine completions get flagged: a shared #cf= link restores the
        // result without the visitor having answered anything.
        setQuizUserFlag();
        track('quiz_complete', {
          quiz_family: familyFromAnswers(),
          quiz_format: answers.format || '',
          quiz_caffeina: answers.caffeina || '',
          quiz_winner: ranked[0] ? ranked[0].dataset.handle : ''
        });
        var h = answersToHash();
        if (h && window.history && history.pushState) history.pushState({ cf: 1 }, '', h);
      }
      resultBody.innerHTML = isCaps ? renderCapsule(ranked) : renderFresh(ranked);
      if (intro) intro.classList.add('cf__intro--result'); // resta solo il titolo
      quiz.hidden = true;
      resultWrap.hidden = false;
      // rebind restart button that we just injected
      resultBody.querySelectorAll('[data-cf-restart]').forEach(function (b) {
        b.addEventListener('click', resetQuiz);
      });
      scrollToQuizTop();
      var focusEl = resultBody.querySelector('.cf__profile-name') || resultBody.querySelector('h2, h3');
      if (focusEl) { focusEl.setAttribute('tabindex', '-1'); focusEl.focus({ preventScroll: true }); }
    }

    // Back/forward between quiz and result states
    window.addEventListener('popstate', function () {
      var fromHash = answersFromHash();
      if (fromHash) {
        answers = fromHash;
        paintSelections();
        computeResult(true);
      } else if (!resultWrap.hidden) {
        resultWrap.hidden = true;
        if (intro) intro.classList.remove('cf__intro--result');
        quiz.hidden = false;
        showStep(total - 1, true);
      }
    });

    // Link with ?formato=moka: the first answer is already known, so the quiz
    // records it and opens straight on the second question (no quiz_step_1).
    // From a blog article (&da=blog…, snippets/article-quiz.liquid) the reader
    // really answered there, so quiz_start is sent now. From any other source
    // (ads: &da=annuncio) quiz_start waits for the first real answer in
    // commitAnswer, quiz_format already set.
    // No focus move: on a fresh page load it would draw the theme's focus ring.
    function startFromLink() {
      var fmt = '';
      var from = '';
      try {
        var params = new URLSearchParams(window.location.search);
        fmt = params.get('formato') || '';
        from = (params.get('da') || '').toLowerCase();
      } catch (e) { return; }
      fmt = fmt.toLowerCase().replace(/[^a-z]/g, '');
      var first = steps[0];
      if (!fmt || !first || first.dataset.axis !== 'format') return;
      var opt = first.querySelector('.cf__opt[data-value="' + fmt + '"]');
      if (!opt) return;
      opt.classList.add('is-selected');
      opt.setAttribute('aria-pressed', 'true');
      answers.format = fmt;
      if (from.indexOf('blog') === 0) {
        quizStarted = true;
        track('quiz_start', { quiz_format: fmt });
      }
      showStep(1);
      scrollToQuizTop(quiz);
    }

    // Deep link (#cf=...): restore the shared/refreshed result directly
    var restoredAnswers = answersFromHash();
    if (restoredAnswers) {
      answers = restoredAnswers;
      paintSelections();
      computeResult(true);
    } else {
      showStep(0);
      startFromLink();
    }
  }

  function boot() {
    document.querySelectorAll('[data-coffee-finder]').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init inside the Shopify theme editor when the section reloads
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-coffee-finder]').forEach(initFinder);
  });
})();
